/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
const _ENV_NAME = process.env.REACT_APP_ENV_NAME;
const REPUVE = process.env.REACT_APP_REPUVE;

const ENV_NAME = REPUVE ? 'repuve' : _ENV_NAME;
const NAYARIT = ENV_NAME === 'nayarit';

// logos
export const logo = require(`./${ENV_NAME}/logo-header.${REPUVE ? 'svg' : 'png'}`).default;
export const logoHeader = require(`./${ENV_NAME}/logo-finanzas.${REPUVE ? 'svg' : 'png'}`).default;

// Banners
export const publicidad = NAYARIT ? require(`./${ENV_NAME}/images/banner.jpg`).default : null;

// miscelaneous
export const bg = require(`./${_ENV_NAME}/bg.png`).default;
export const asistencia = require(`./${_ENV_NAME}/asistencia-contribuyente.svg`).default;

// export const banner = require(`./${_ENV_NAME}/banner.png`).default;
// export const logoEslogan = require(`./${_ENV_NAME}/logo-slogan.png`).default;

export const carouselImg1 = require('./oaxaca/banner-01.jpg').default;

export const icono1 = require('./oaxaca/icono-1.jpg').default;
export const icono2 = require('./oaxaca/icono-2.jpg').default;
export const icono3 = require('./oaxaca/icono-3.jpg').default;
export const icono4 = require('./oaxaca/icono-4.jpg').default;
